import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/main.css'

// Import Inter font from Google Fonts
const link = document.createElement('link')
link.rel = 'stylesheet'
link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap'
document.head.appendChild(link)

const app = createApp(App)
app.mount('#app')
